<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    @if (fields()) {
      <IAlert
        title="CSV format should contains all the following fields, separated by tabs"
        [collapsable]="true"
        [isOpen]="false"
      >
        <ul class="flex max-h-[200px] flex-col gap-1 overflow-y-auto text-sm">
          @for (value of fields(); track value) {
            <li>
              <span class="font-medium italic">{{ value.field }} : </span>
              <span
                ><code>{{ value.description }}</code></span
              >
            </li>
          }
        </ul>

        <div class="mt-4">
          <pre class="coding-font">{{ bulkExample() }}</pre>
        </div>
      </IAlert>
    }

    <textarea
      #textarea
      autofocus
      class="h-[250px] resize-y"
      type="text"
      [placeholder]="t('strategy-bulk-upload-modal.paste_csv_here')"
      [value]="textareaValue()"
      (input)="textareaInputChange($event)"
      (keydown)="handleKeydown($event)"
    ></textarea>

    <button iButton class="self-end" [disabled]="!textareaValue()" (click)="onTextareaUpload.emit(textareaValue())">
      {{ t("common.upload") }}
    </button>

    <div class="mx-auto my-3 text-center text-sm font-medium text-gray-400 uppercase">{{ t("common.or") }}</div>

    <div class="w-full">
      <input
        #fileInput
        hidden
        type="file"
        accept="text/csv"
        (input)="onCsvFileUpload.emit(fileInput.files)"
        (click)="fileInput.value = ''"
      />
      <button iButton variant="secondary" class="w-full" (click)="fileInput.click()">
        <IIcon name="upload" />
        {{ t("common.upload_csv") }}
      </button>
    </div>

    @if (fileUploadError()) {
      <div class="text-sm text-red-500">{{ fileUploadError() }}</div>
    }
  </div>
</ng-container>
